var React = require('react');
var ReactNative = require('react-native');

var Globals = require('./Globals');
var NetworkManager = require('./NetworkManager.js');
var ModelConstants = require('./constants/ModelConstants.js');
var ReUpButton = require('./ReUpButton.js');
var ReUpField = require('./ReUpField.js');
var ReUpIconButton = require('./ReUpIconButton.js');
var ReUpText = require('./ReUpText');
var LinkingManager = require('./wrappers/LinkingManager');
var createReactClass = require('create-react-class');
var Icon = require('./wrappers/ReUpIcon');

var MK = require('./wrappers/react-native-material-kit-wrapper');
var {
  MKColor,
  MKCardStyles,
  MKTextField,
  MKIconToggle
} = MK;

var {
  AppRegistry,
  Text,
  View,
  Image,
  ScrollView,
  Platform,
  StyleSheet,
} = ReactNative;

function findGetParameter(parameterName)
{
  var result = null,
    tmp = [];
  location.search
    .substr(1)
    .split("&")
    .forEach(function (item)
    {
      tmp = item.split("=");
      if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
    });

  return result;
}

var TermsPreferences = createReactClass(
{
  getDefaultProps : function()
  {
    var userID = findGetParameter("userid");
    var hash = findGetParameter("hash");
    return {
      appManager : null,
      userID,
      hash,
    }
  },

  getInitialState : function()
  {
    return {
      layout : this.props.initialLayout,
      user : this.props.appManager.currentUser(),
      showPassword : false,
      selfieURL : null,
      hasOptedInForPhone : this.props.appManager.isLoggedIn() && this.props.appManager.currentUser()["hasOptedInForPhone"]
    }
  },

  componentDidMount : function()
  {
    this.refreshUser();
  },

  contactSupport: function()
  {
    var email = "hello@getreup.com";
    var platform = Platform.OS;
    if( platform == "android" ) platform = "Android";
    var subject = this.props.appManager.appNameLong + " Support";
    var body = "Hi, I am having an issue with...";

    var appManager = this.props.appManager;
    var locMan = appManager.getLocalizationManager();
    if( this.props.appManager.currentUser() != null )
    {
      var userName = appManager.currentUser()[ModelConstants.UserName];
      if( appManager.isValidEmail(userName) ) body = "Hi, my email is " + userName + " and I am on " + platform + ". I am having an issue with...";
      else body = "Hi, my phone number is " + locMan.localizedPhone(userName) + " and I am on " + platform + ". I am having an issue with...";
    }

    var url = "mailto:"+encodeURI(email)+"?subject="+encodeURI(subject)+"&body="+encodeURI(body);
    LinkingManager.openURL(url)
  },

  refreshUser: function()
  {
    var appManager = this.props.appManager;
    var userID = this.props.userID;
    var hash = this.props.hash;
    if( this.state.user != null )
    {
      userID = this.state.user[ModelConstants.UserID];
      hash = this.state.user[ModelConstants.Hash];
    }
    var thisThing = this;
    NetworkManager.getUser(appManager, userID, hash, (data)=>
    {
      thisThing.setState({hasOptedInForPhone:data["HasOptedInForPhone"]});
      appManager.setCurrentUser(data);
    }, ()=>
    {
      console.log("couldn't refresh user")
    })
  },

  unsubscribe: function()
  {
    var appActions = this.props.appActions;
    var appManager = this.props.appManager;
    var userID = this.props.userID;
    var hash = this.props.hash;
    if( this.state.user != null )
    {
      userID = this.state.user[ModelConstants.UserID];
      hash = this.state.user[ModelConstants.Hash];
    }
    var thisThing = this;
    appActions.showAlert("Confirmation",
      "Are you sure you want to unsubscribe?",
      ["No","Unsubscribe"],
      [function(){appActions.hideAlert();}, function()
      {
        thisThing.setState({hasOptedInForPhone:false});
        appActions.hideAlert();
        NetworkManager.optOutPhone(appManager, userID, hash, ()=>
        {
          thisThing.refreshUser();
        }, ()=>
        {

        })
      }]);
  },

  subscribe: function()
  {
    var appManager = this.props.appManager;
    var userID = this.props.userID;
    var hash = this.props.hash;
    if( this.state.user != null )
    {
      userID = this.state.user[ModelConstants.UserID];
      hash = this.state.user[ModelConstants.Hash];
    }
    var thisThing = this;
    NetworkManager.optInPhone(appManager, userID, hash, ()=>
    {
      thisThing.setState({hasOptedInForPhone:true});
      thisThing.refreshUser();
    }, ()=>
    {

    })
  },

  showTerms: function()
  {
    var tosLink = this.props.appManager.getTermsLink();
    LinkingManager.openURL(tosLink)
  },

  render: function()
  {
    var thisThing = this;
    var appManager = this.props.appManager;
    var locManager = appManager.getLocalizationManager();
    var headerImage = appManager.absoluteResourceForPath("Feed/header.png");

    var stripHeight = 60;
    var textWarning = "By signing up with your phone number you agree to receive updates on your reward balance";
    var unsubscribe = "You may unsubscribe at any time.";
    var messageRates = "Standard message rates apply.";

    var generalColor = appManager.getColorForKey("GeneralColor");
    var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");

    return (
      <View style={styles.container}>
        <View style={{flex:1, alignSelf:'stretch', justifyContent:'center', alignItems:'center',padding:20, backgroundColor:generalColor}}>
          <View style={{alignSelf:'stretch', marginBottom:20}}>
            <Image style={{width:'100%', height:stripHeight}} resizeMode={"contain"} source={{uri: headerImage}} />
          </View>
          <View style={{margin:4}}>
            <ReUpText appManager={appManager} style={{textAlign:'center', color:generalTitleColor}}>
            {textWarning}
            </ReUpText>
          </View>
          <View style={{margin:4}}>
            <ReUpText appManager={appManager} style={{textAlign:'center', color:generalTitleColor}}>
            {unsubscribe}
            </ReUpText>
          </View>
          <View style={{margin:4}}>
            <ReUpText appManager={appManager} style={{textAlign:'center', color:generalTitleColor}}>
            {messageRates}
            </ReUpText>
          </View>
          <View style={{flex:1}} />
          {
            this.state.hasOptedInForPhone ?
              <ReUpButton appManager={appManager} isSecondary={true} style={{margin:0, width:240}} text={locManager.localizedStringForKey("UNSUBSCRIBE_BUTTON")}
                onPress={()=>
                {
                  thisThing.unsubscribe();
                }} />
            :
              <ReUpButton appManager={appManager} isSecondary={true} style={{margin:0, width:240}} text={locManager.localizedStringForKey("SUBSCRIBE_BUTTON")}
                onPress={()=>
                {
                  thisThing.subscribe();
                }} />
          }
          <View style={{height:8}} />
          <ReUpButton appManager={appManager} isSecondary={true} style={{margin:0, width:240}} text={locManager.localizedStringForKey("TERMS_AND_CONDITIONS_BUTTON")}
            onPress={()=>
            {
              thisThing.showTerms();
            }} />
          <View style={{height:8}} />
          <ReUpButton appManager={appManager} isSecondary={true} style={{margin:0, width:240}} text={locManager.localizedStringForKey("SUPPORT_BUTTON")}
            onPress={()=>
            {
              thisThing.contactSupport();
            }} />
          <View style={{flex:1}} />
        </View>
      </View>
    );
  }
});

var styles = StyleSheet.create({
  container:{
    flex: 1,
    flexDirection: 'column',
  }
});

TermsPreferences.dataDependencies = [];

module.exports = TermsPreferences;
